import React from 'react';
import CountUp from 'react-countup';

const FunFact = (props) => {

    return (
        <section className={"" + props.hclass} >
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-doctor"></i>
                            <h3>+<CountUp end={3} enableScrollSpy /></h3>
                            <p>Años siendo lideres</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-businesswoman"></i>
                            <h3>+<CountUp end={1500} enableScrollSpy /></h3>
                            <p> Pacientes atendidos</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-award"></i>
                            <h3>+<CountUp end={7} enableScrollSpy /></h3>
                            <p>Especialidades</p>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="item">
                            <i className="flaticon-customer-care"></i>
                            <h3>+<CountUp end={10} enableScrollSpy /></h3>
                            <p>Tecnologias usadas</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default FunFact;